import Vue from "vue";
import Router from "vue-router";
import views from "@/views";
import docCookies from "@/utils/docCookies.js";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      component: views.Login,
      props: route => ({
        internalUrl: route.query.redirect,
        externalUrl: route.query.redirectUrl
      })
    },
    {
      path: "/",
      component: views.Layout,
      children: [
        {
          path: "",
          redirect: { name: "Dashboard" }
        },
        {
          path: "dashboard",
          name: "Dashboard",
          component: views.Dashboard,
          meta: { requiresAuth: true }
        },
        {
          path: "profile",
          name: "profile",
          component: views.Profile.Home,
          meta: { requiresAuth: true }
        },
        {
          path: "settings/org",
          name: "organization",
          component: views.Organization.Home,
          meta: { requiresAuth: true }
        },
        {
          path: "settings/team",
          name: "team",
          component: views.Team.Team.List,
          meta: { requiresAuth: true }
        },
        {
          path: "settings/team/:teamId",
          name: "teamMembers",
          component: views.Team.Member.List,
          meta: { requiresAuth: true, activeIndex: "/settings/team" },
          props: true
        },
        {
          path: "settings/member",
          name: "member",
          component: views.User.List,
          meta: { requiresAuth: true }
        }
      ]
    },
    // default route
    {
      path: "*",
      redirect: { name: "Dashboard" }
    }
  ]
});

// 在路由更新之前都去遍历路由的meta元信息, 判断有没有requiresAuth
router.beforeEach((to, from, next) => {
  // 如果有requiresAuth, 则开始验证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 如果无法从Cookie中获取token, 则重定向到login页面
    if (docCookies.hasItem("vsat-iam")) {
      next();
    } else {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath
        }
      });
    }
  } else {
    // Required, DO NOT OMITTED
    next();
  }
});
export default router;
